import classNames from 'classnames';
import { Fragment } from 'react';
import seedrandom from 'seedrandom';

import styles from '../../styles/partials/placeholder-text.module.css';

interface PlaceholderTextProps {
    lines?: number;
    characters?: number | null;
    minCharacters?: number;
    maxCharacters?: number;
    className?: string | null;
}

function PlaceholderText({
    lines: linesCount = 1,
    characters = null,
    minCharacters = 8,
    maxCharacters = 12,
    className = null,
}: PlaceholderTextProps) {
    const rand = seedrandom(`${minCharacters}-${maxCharacters}`);
    const lines = [...Array(linesCount).keys()].map(() => ({
        id: rand().toString(36).slice(2),
        charactersCount:
            characters || minCharacters + Math.round(rand() * (maxCharacters - minCharacters)),
    }));

    return (
        <span className={classNames([styles.container, className])}>
            {lines.map(({ id, charactersCount }, index) => (
                <Fragment key={`line-${id}`}>
                    {`${index > 0 ? '\n' : ''}${[...Array(charactersCount).keys()].map(() => '█').join('')}`}
                </Fragment>
            ))}
        </span>
    );
}

export default PlaceholderText;
